import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'numberSeperator',
  standalone: true
})
export class NumberSeperatorPipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    if (value === 0) return '0';
    if (!value) return '-';

    const isFloat = value % 1 !== 0;
    const formattedValue = isFloat ? value.toFixed(2) : value.toString();

    return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
  }
}
